module.exports = require("node-telegram-bot-api");